import React from 'react'
import './services.css'
import {servicesData} from '../../data'
import {Link} from 'react-router-dom'
import Footer from '../../components/Footer'
import ContactUs from '../../components/ContactUs'
import '../home/home.css'
import Card from '../../UI/Card'


const Services = () => {
  const index = 0;
  return (
    <div className='services'>
      <div className='services__Container'>
        <div className='services__Wraper'>
          <div className='services__ContentContainer'>
            <div className='services__HeadLineWrapper'>
              <div className='services__HeadLineContent'>
                <div className='services__HeadLineContentContainer'>
                  <h1>{servicesData[index].title}</h1>
                  <p className='services__Description'>{servicesData[index].description}</p>
                  <div className='services__ContactButtonContent'>
                    <Link to="/contact" className='white_btn btn'>LET'S TALK</Link>
                  </div>
                </div>
                <div className='services__ImageWrapper'>
                  <div className='services__ImageCanvas'>
                    <img className='' src={servicesData[index].image} alt={servicesData[0].title}/>
                  </div>
                </div>
              </div>
            </div> 
          </div>
          <div className='services__FeaturesListWrapper'>
            <div className='services__FeaturesContainer'>
              <ul className='services__FeaturesList'>
              {
                servicesData[index].children.map(({feature, feature_description}) => {
                  return (
                    <li className='' key={index}>
                      <Card className="">
                        <h3>{feature}</h3>
                        <small>{feature_description}</small>
                      </Card>
                    </li>
                  )
                })
              }
              </ul>
            </div>
          </div>
          <div className='services__Industries'>
              <div className='services__IndustriesContainer'>
              <h1>Industries</h1>
              <div className='services__Industries__ListWrapper'>
                {
                  servicesData[index].industries.map(({head, lines}) => {
                    return (
                      <li className='' key={index}>
                        <div className='services__Industries__ListHead'><h3>{head}</h3></div>
                        <div className='services__Industries__ListLines'><p>{lines}</p></div>
                      </li>
                    )
                  })
                }
              </div>
              </div>
          </div>
          <ContactUs/>
          <Footer/>
        </div>
      </div>
    </div>
  )
}

export default Services